import React from "react";
import Navbar from '../navBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/md-dark-indigo/theme.css";
import "primereact/resources/primereact.min.css"
import 'primeicons/primeicons.css';
import 'react-slideshow-image/dist/styles.css'
import { useTranslation } from "react-i18next";
import FooterComponent from "../footer";
import "../../style/table.css"
import TableFeldspat from "../feldspatTable";
import { Menu } from "primereact/menu";
import MixFeldspatMenu from "../mixFeldspatMenu"
import "../../style/commonMobile.css";

const MixFeldspatK8000 = (props) => {
    const { t, i18n } = useTranslation();
    return (
        <PrimeReactProvider>
            <Navbar />
            <div className="feldspatContainer">
                <div style={{ display: "block" }}>
                    <MixFeldspatMenu />
                </div>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center" }}>
                    <TableFeldspat baslik="TEKNOMADEN MIX FELDSPAR (-10MM) 98K8000 TDS" plantAddress="Yeşilköy/Kavaklıdere/Muğla" kod="98K8000" humidity="3" oilAbsorb="" na2o="4.88" k2o="3.96" cao="0.31" fe2o3="1.38" tio2="0.16" al2o3="16.18" mgo="0.30" p2o5="0.22" sio2="72.30" kk="0.30" l="74,04" a="2,48" b="12,47" albit="41.30" ortoklas="23.40" anortit="1.50" kaolinit="8.29" kuvars="25.50" />
                </div>
            </div>
            <FooterComponent />
        </PrimeReactProvider>
    );
}
export default MixFeldspatK8000;